import Vue from 'vue';
import axios from 'axios';
import App from './App.vue';
import store from './store/index';
import vuetify from './plugins/vuetify'
import "./js/app";
import '../public/assets/css/printStyle.css'
import vSelect from "vue-select";

Vue.config.productionTip = false;
Vue.prototype.myWindow = window;
Vue.component("vc-select", vSelect);

async function initApp() {
  try {
    const response = await fetch('./config.json');
    const config = await response.json();

    window.APP_CONFIG = config;
    
    document.title = config.TITLE;
    axios.defaults.baseURL = config.API_ENDPOINT;
    
    console.log('Runtime Config:', config);
    console.log('API Endpoint:', config.API_ENDPOINT);
  } catch (error) {
    console.warn('Config not found, using env variables');
    document.title = process.env.VUE_APP_TITLE;
    axios.defaults.baseURL = process.env.VUE_APP_API_ENDPOINT;
  }

  new Vue({
    vuetify,
    render: h => h(App),
    store
  }).$mount('#app')
}

initApp();

